<template>
  <div class="payment-feedback">
    <div v-if="isSuccess" class="status-card success">
      <div class="header">
        <span class="icon">✅</span>
        <h1>付款成功</h1>
      </div>
      <div class="body">
        <p>訂單編號：{{ orderId }}</p>
        <p>感謝您的購買！</p>
      </div>
      <button @click="next" class="btn btn-primary">回商店繼續逛</button>
      <!-- <router-link to="/shop" class="btn">回商店繼續逛</router-link> -->
    </div>

    <div v-else class="status-card failure">
      <div class="header">
        <span class="icon">❌</span>
        <h1>交易未完成</h1>
      </div>
      <div class="body">
        <p>訂單編號：{{ orderId }}</p>
        <p class="error-detail">{{ errorMsg }}</p>
      </div>
      <div class="actions">
        <button @click="next" class="btn btn-primary">重新嘗試</button>
        <router-link to="/support" class="btn btn-text">聯繫客服</router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();
const router = useRouter();

// 判斷是否成功的邏輯
const qr = computed(() => route.query.qr );
const isSuccess = computed(() => route.query.pay_res === '1');
const orderId = computed(() => route.query.order_id || '未知');
const errorMsg = computed(() => route.query.em || '交易失敗，請檢查信用卡資訊');

const retry = () => router.push('/checkout');
const next = () => router.push(`/menu_order/${qr.value}`);
</script>